import { Component, OnInit } from '@angular/core';
import { HandlerService } from '../handler.service';
import { ApiService } from '../api.service';
import { Platform } from '@ionic/angular';
import { Router } from '@angular/router';

@Component({
  selector: 'app-category-items',
  templateUrl: './category-items.component.html',
  styleUrls: ['./category-items.component.scss'],
})
export class CategoryItemsComponent  {

  loader: boolean = true;
  category;
  name;
  search:any=[];
  filterLength;
  img;
  constructor(    private router: Router,  public handler: HandlerService, private platform: Platform,
    public service: ApiService) { }
ionViewWillEnter(){
  this.getCategory();
}
getCategory(){
  this.service.getOrgCategoryDetails().subscribe((res: any) => {
    if(res){
      this.category=res;
      this.img = res.img;
      this.name=res.name;
      this.loader = false;
    }else{
      this.handler.res("No Data Found");
      this.loader = false;
    }
    
  },err=>{
    this.handler.err(err);
    this.loader=false;
  })
}

deleteCategories(id){
  this.loader=true;
  this.service.deleteCategory(id).subscribe(res=>{
    this.loader=false;
    this.handler.res("Deleted successfully")
    this.getCategory();
 
    this.router.navigate(['/category'])
  },
  err=>{
    this.handler.err(err)
    this.loader=false
  })
}  

route(id){
  this.router.navigate(['edit-category/', +id]);
}

refreshData(event){
  this.loader = true; 
  this.ionViewWillEnter();
  setTimeout(() => {
    event.target.complete();
  }, 1000);
}

ionViewWillLeave(){
  this.search="";
}
clear(){
  this.search="";
}
ngDoCheck(): void {
  this.filterLength = sessionStorage.getItem('len')

}
}
